import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {defaultVariables} from "../../../../config";
import Button from "@mui/material/Button";
import {Upload,Paperclip} from "lucide-react";

const UploadPrivateFile = ({setFile,title,init}) => {
    const { t } = useTranslation();

    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const token = localStorage.getItem("ACT");

    const uploadFile = async (file) => {
        if (!file) return;
        setUploading(true);

        const formData = new FormData();
        const isImage = file.type.startsWith("image");
        formData.append("file", file);
        formData.append("type", isImage ? "image" : "document");

        try {
            const response = await axios.post(`${defaultVariables.url}/file/add-private`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                },
            });
            setUploadedFile(response.data);
            setFile(response.data)
        } catch (error) {
            console.error("Error uploading file:", error.response?.data || error.message);
        } finally {
            setUploading(false);

        }
    };
    useEffect(() => {
        setUploadedFile(init)
    }, [init]);
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            uploadFile(file);
        }
    };
    return (
        <>
            <Button
                component="label"
                variant="outlined"
                color="secondary"
                disabled={uploading}
                startIcon={<Upload/>}
            >
                {title}
                <input type="file" /*accept="image/*"*/ hidden onChange={handleFileChange} />
            </Button>
            {
                !!uploadedFile &&
                <div className="mt-10 mb-10">
                    {
                        uploadedFile.type === "image" ?
                            <a target="_blank" href={`${defaultVariables.uploads}/doc/${uploadedFile.name}.${uploadedFile.extension}`}>
                                <img src={`${defaultVariables.uploads}/doc/${uploadedFile.name}.${uploadedFile.extension}`} width={100}/>
                            </a>
                            :
                            <Button
                                startIcon={<Paperclip/>}
                                component="a"
                                href={`${defaultVariables.uploads}/doc/${uploadedFile.name}.${uploadedFile.extension}`} target="_blank" >
                                {t('viewFile')}
                            </Button>
                    }
                </div>
            }
        </>
    );
};

export default UploadPrivateFile;
